import React from "react";
import { User } from "lucide-react";
import type Contact from "@/model/interface/Contact";
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
import { getInitials, getContactDisplayName } from "@/util/string";

export function QueuedContactItem({ contact, detail }: { contact?: Contact; detail?: string }) {
  const displayName = (contact && getContactDisplayName(contact)) ?? "Unknown";
  const initials = getInitials(contact?.firstName, contact?.lastName);
  const secondLine = detail ?? contact?.company;

  return (
    <div className="flex items-center gap-3 rounded-md px-1 py-2.5">
      <Avatar className="h-9 w-9">
        {contact?.photo && <AvatarImage src={contact.photo} alt={displayName} />}
        <AvatarFallback className="bg-primary/10 text-sm font-semibold text-primary">
          {initials !== "?" ? initials : <User className="h-4 w-4" />}
        </AvatarFallback>
      </Avatar>
      <div className="min-w-0 flex-1">
        <p className="truncate text-base font-semibold dark:text-white">{displayName}</p>
        {secondLine && <p className="truncate text-sm text-muted-foreground">{secondLine}</p>}
      </div>
    </div>
  );
}
